import { productGalleryTabsSX } from '@/components/blocks/ProductDetails/styles/productGalleryTabs';
import { Box } from '@mui/material';

interface TabPanelProps {
	children?: React.ReactNode;
	value: string;
	hidden: boolean;
}

export const ProductTabPanel = ({ children, value, hidden }: TabPanelProps) => (
	<Box
		role="tabpanel"
		hidden={hidden}
		id={`simple-tabpanel-${value}`}
		aria-labelledby={`simple-tab-${value}`}
		sx={productGalleryTabsSX.tabContainer}
	>
		{children}
	</Box>
);
